
import { Dapp } from '@/types'
import { defineComponent, PropType } from 'vue'
import DappBlock from './DappBlock.vue'
import Header from './Header.vue'


export default defineComponent({
    name: 'Dapps',
    components: {
        DappBlock,
        Header
    },
    props: {
        listName: String,
        dapps: {
            type: Array as PropType<Array<Dapp>>, // or Array<DappLocalState>
            required: true,
        }
    },
})
